import { space } from '../tokens';
import {
  dropdownMenuContent,
  dropdownMenuItem,
  dropdownMenuItemIndicator,
} from '../dropdown-menu/dropdown-menu.css';
import { style } from '../layer.css';

export const comboboxRoot = style({
  position: 'relative',
  display: 'inline-block',
  width: '100%',
});

export const comboboxListbox = style([
  dropdownMenuContent,
  {
    // Radix Dialog sets pointer-events: none on body; the popup portals there.
    pointerEvents: 'auto',
    maxHeight: 'min(var(--available-height), 400px)',
    width: 'var(--anchor-width)',
    maxWidth: 'var(--available-width)',
    transformOrigin: 'var(--transform-origin)',
    transition: 'opacity 0.1s, transform 0.1s',

    selectors: {
      '&[data-ending-style]': {
        opacity: 0,
        transform: 'scale(0.95)',
      },
      '&[data-empty]': {
        padding: 0,
      },
    },
  },
]);

export const comboboxOption = style([dropdownMenuItem]);

export const comboboxActionButtons = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s6,
  position: 'absolute',
  right: space.s16,
});

export const comboboxItemIndicator = style([dropdownMenuItemIndicator]);
